export enum presenceOpenHours {
  SPECIFIC_OPEN_HOURS = 'specific_opening_hours',
  GENERAL_OPEN_HOURS = 'general_opening_hours',
  CLOSE_OPEN_HOURS = 'closed_day',
  DEFAULT_OPEN_HOURS = 'default_opening_hours',
}
